import SalarieFiscalite from '@/generated/controls/salarie/SalarieFiscalite.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieFiscalite
})
